export default "__VITE_ASSET__BbAmcdDk__"